import { useSelector } from 'react-redux';
import { RootState } from '../store/store';
import { selectNotesForToolbar } from '../store/selectors/notes';

/**
 * Unread in-app notification count, exactly as the notification bell
 * (`MainButtons`) shows it.
 *
 * This reads redux state that `MainButtons` already populates via
 * `fetchNotes` and its socket listeners (`messages created`,
 * `notifications created`) — it does not fetch or subscribe on its own, so
 * mounting it elsewhere (the PWA badge) never duplicates that query.
 */
const useUnreadCount = (): number => {
  const notes = useSelector((state: RootState) => selectNotesForToolbar(state));
  return notes.filter((note) => note.read === false).length;
};

export default useUnreadCount;
